<template>
  <div class="wrapper">
    <span ref="newUserButton" class="pull-right">
      <button class="btn btn-primary btn-fill" id="show-modal" @click.stop="showModal()">+ Add New User</button>
    </span>
    <user-modal v-show="isModalVisible" @close="closeModal"/>
    <h3 class="page-header">Account Settings</h3>
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <edit-profile-form>
        </edit-profile-form>
      </div>
    </div>
    <div class="row" v-if="profiles.length > 0">
      <div class="col-md-3 error_height">
        <div class="form-group">
          <label>Filter:</label>
          <input type="text" v-model="searchText" class="form-control border-input" placeholder="Start Typing"/>
        </div>
      </div>
    </div>
    <h3 v-if="support" class="page-header">Manage Users</h3>
    <template v-for="(item, key, index) in profilesSearch"></template>
    <div v-if="current != item.email" v-for="(item, key, index) in profilesSearch" class="card card-user">
      <div class="content">
        <div class="row">
          <div class="col-md-3">
            <h4 class="user-name">{{item.fname + ' ' + item.lname}}</h4>
            <span v-if="item.role == 14" class="role">Corporate</span>
            <span v-if="item.role == 15" class="role">Regional</span>
            <span v-if="item.role == 16" class="role">Single</span>
          </div>
          <div class="col-md-3 user-email">
            {{item.email}}
          </div>
          <div class="col-md-3 user-phone">
            {{item.phone}}
          </div>
          <span v-if="support || corp" class="col-md-1 pull-right">
            <button class="btn btn-primary edit-user" @click="deleteUser(item.uid, item.fname, item.lname)">Delete</button>
          </span>
          <span class="col-md-2 pull-right">
            <button class="btn btn-primary btn-wd edit-user" id="show-modal" @click.stop="showModal(item.email)">Edit</button>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {API} from 'src/api'
  import EditProfileForm from './UserProfile/EditProfileForm.vue'
  import PortalNotification from 'src/components/UIComponents/NotificationPlugin/Notification.vue'

  if(localStorage.userInfo) {
    var userInfo = JSON.parse(localStorage.userInfo)
    var support = ''
    var corp = ''
    if(userInfo.company == 'Support') {
      support = true
    } else {
      support = false
    }
    if(userInfo.role == 14) {
      corp = true
    } else {
      corp = false
    }
  }
  export default {
    components: {
      EditProfileForm,
      PortalNotification
    },
    data () {
      return {
        searchText: '',
        profiles: [],
        current: '',
        support: support,
        corp: corp,
        editUser: '',
        delete: '',
        isModalVisible: false
      }
    },
    methods: {
      showModal (email) {
        this.isModalVisible = true
        var input = this.$children[0]
        var self = this
        var company = []
        var np_selected = [{ CODE: '', NAME: ''}]
        var nps = []
        var array = []
        var stopLoop = false
        var role = 16
        if(email) {
          API.get('/profile/' + encodeURIComponent(email) + '?npuser=true')
          .then(function (response) {
            array = response.data.company ? response.data.company.split(',') : [];
            role = response.data.role;
            for (let partner of array) {
              if(stopLoop) break;
              // Hack for Five Guys and Dickey's
              if (partner.includes("fiveguys", "dickeysbbq") && role == 14) {
                stopLoop = true
              }
              API.get('/report/partners/'+partner.toLowerCase())
              .then(function (response) {
                for (let np of response.data.rv) {
                  // Hack for Five Guys and Dickey's
                  if (np.CODE.includes("fiveguys") && role == 14) {
                      self.$children[0].np_selected.push({
                        CODE: 'fiveguys',
                        NAME: 'Five Guys',
                      });
                      stopLoop = true
                  } else if (np.CODE.includes("dickeysbbq") && role == 14) {
                      self.$children[0].np_selected.push({
                        CODE: 'dickeysbbq',
                        NAME: 'Dickey\'s BBQ ',
                      });
                      stopLoop = true
                  } else {
                      self.$children[0].np_selected.push({
                        CODE: np.CODE,
                        NAME: np.NAME,
                      });
                  }
                }
              })
            }

            self.$children[0].getRestaurants(response.data);
            input.FNAME = response.data.fname
            input.LNAME = response.data.lname
            input.EMAIL = response.data.email
            input.PHONE = response.data.phone
            //input.COMPANY = response.data.company.toLowerCase()
            //input.COMPANY = np_selected
            input.ROLE = response.data.role
            input.UID = response.data.uid
            input.modalHeading = 'Edit User'
            input.modalButtonText = 'Update User'
            input.checkedRestaurants = response.data.extid.split(',')
          })
          .catch(function (error) {
            console.log(error)
          })
        } else {
          input.FNAME = ''
          input.LNAME = ''
          input.EMAIL = ''
          input.PHONE = ''
          input.COMPANY = ''
          input.ROLE = ''
          input.UID = ''
          input.modalHeading = 'New User'
          input.modalButtonText = 'Create User & Send Invitation'
          input.checkedRestaurants = []
          input.npuser = true
        }
      },
      closeModal () {
        this.isModalVisible = false
      },
      deleteUser (uid, fname, lname) {
        this.delete = confirm("Are you sure you want to delete " + fname + " " + lname + "'s profile?");
        if (this.delete == true) {
          var self = this
          API.delete('/profile/' + uid + '?npuser=true')
          .then(function (response) {
            // console.log(response)
            self.notifyVue('top', 'center', 'The user has been deleted!', 'ti-check-box', 'success')
          })
          .catch(function (error) {
            console.log(error)
            self.notifyVue('top', 'center', 'There was a problem deleting the user', 'ti-alert', 'danger')
          })
        }
      },
      getUsers () {
        var self = this
        API.get('/profile?npuser=true&company=' + userInfo.company + '&role=' + userInfo.role + '&uid=' + userInfo.uid)
        .then(function (response) {
          //console.log(response.data.profiles)
          self.profiles = response.data.profiles
          self.current = userInfo.email
        })
        .catch(function (error) {
          console.log(error)
        })
      },
      notifyVue (verticalAlign, horizontalAlign, message, icon, type) {
        this.$notifications.notify(
          {
            message: message,
            icon: icon,
            horizontalAlign: horizontalAlign,
            verticalAlign: verticalAlign,
            type: type
          })
      }
    },
    computed: {
      profilesSearch:function() {
      	 var self = this;
         //console.log(this.searchText)
         if( this.searchText == ''){
           return this.profiles;
         }
         return this.profiles.filter(function(item){
           if(item.fname.toLowerCase().indexOf(self.searchText.toLowerCase())>=0) {
             return item;
           }
           if(item.lname.toLowerCase().indexOf(self.searchText.toLowerCase())>=0) {
             return item;
           }
           if(item.email.toLowerCase().indexOf(self.searchText.toLowerCase())>=0) {
             return item;
           }
           if(item.phone.toLowerCase().indexOf(self.searchText.toLowerCase())>=0) {
             return item;
           }
         });
      }
    },
    mounted () {
      if(userInfo.role == 16) {
        this.$refs.newUserButton.hidden = true
      }
    },
    created () {
      this.getUsers()
    }
  }
</script>
<style scoped>
.card .header {
  text-align: left !important;
}
.user-name {
  margin: 0;
}
.user-email, .user-phone {
  font-size: 16px;
  top: 15px;
  color: #757575;
}
.role {
  color: #757575;
}
.edit-user {
  margin: 4px 0;
}
</style>



// WEBPACK FOOTER //
// UserProfile.vue?8687e30a